import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.admin.data');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-admin-data',
template: templateSource || '',
    styles: [``],
})
export class PortalAdminDataComponent implements OnInit {
    public activeTab: string = 'researcher';
    public tabs: any[] = [
        { value: 'researcher', label: '연구자' },
        { value: 'publication', label: '성과물' },
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }
}

export default PortalAdminDataComponent;